module.exports = __webpack_public_path__ + "static/media/000_gls_leg_r.967c930e.png";